export default __webpack_public_path__ + "static/media/2.38fa3ee4.jpg";